import LocalStorageService from 'lxp-common-functions-js/LocalStorageService'

export const getBooleanFromLocalStorage = (storageKey: string) => {
  const storedValue = LocalStorageService.getItem(storageKey) || 'false'

  try {
    return JSON.parse(storedValue)
  } catch (error) {
    return true
  }
}
